<template>
  <div class="home-page-wrapper about-page-wrapper">
    <HeroBanner
      :title="aboutUs.title"
      :image-url="generateImageUrl(aboutUs.image)"
      image-url-present
    />
    <Social />
    <Message
      title="A Message from our Founder"
      :description="aboutUs.description"
      :signature-image="aboutUs.founderSign"
    />
    <Faq :data="faq" :extra-class="['no-padding-top']" />
  </div>
</template>

<script>
import HeroBanner from "@/pageComponents/globalUi/hero-banner";
import Message from "@/pageComponents/about/message";
import Faq from "@/pageComponents/globalUi/faq";
import Social from '@/pageComponents/social/Social'
import { mapGetters } from "vuex";

const MISC_STORE_KEY = "miscStore";

export default {
  name: "About",
  components: {
    HeroBanner,
    Message,
    Faq,
    Social
  },

  computed: {
    ...mapGetters({
      aboutUs: `${MISC_STORE_KEY}/aboutUs`,
      aboutUsLoading: `${MISC_STORE_KEY}/aboutUsLoading`,
      faq: `${MISC_STORE_KEY}/faq`,
      faqLoading: `${MISC_STORE_KEY}/faqLoading`
    })
  },

  async mounted() {
    await this.$store.dispatch(`${MISC_STORE_KEY}/getAboutUs`);
    await this.$store.dispatch(`${MISC_STORE_KEY}/getFaq`, {
      faqType: "aboutUs"
    });
  }
};
</script>

<style></style>
